import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { makeStyles } from '@material-ui/core/styles';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import { eventCommentsQuery } from '../../apollo/events';
import Comment from './comment';

const useStyles = makeStyles((theme) => ({
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  listItem: {
    margin: theme.spacing(0, 0, 1, 0),
  },
}));

const EventCommentList = ({ event, error, loading }) => {
  const classes = useStyles();

  if (error) { return <ErrorMessage message='Error loading comments.' compact />; }
  if (loading) { return <Loading showProgressTimer={false} compact />; }
  if (!event) { return null; }

  if (!event.comments || !event.comments.length) {
    return null;
  }

  return (
    <ul className={classes.list}>
      {event.comments.map((comment) => (
        <li key={comment.id} className={classes.listItem}>
          <Comment comment={comment} event={event} />
        </li>
      ))}
    </ul>
  );
};

EventCommentList.propTypes = {
  event: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool
};

export default graphql(eventCommentsQuery, {
  props: ({ data: { event, loading, error } }) => {
    return {
      event,
      loading,
      error
    };
  },
  options: ({ event }) => ({
    variables: {
      eventId: event.id
    }
  })
})(EventCommentList);
